@if (widgetFullsizeBannerHeaderAndMessageTogether) {
  <div class="widget-fullsize-banner" [ngClass]="cssClass" [attr.id]="id" [style.margin-top]="marginTop" [style.margin-right]="marginRight" [style.margin-bottom]="marginBottom" [style.margin-left]="marginLeft">
    <img class="mw-100" [src]="imageUrl" [attr.alt]="imageDescription" />
    <div class="header">
      @if (description != undefined) {
        <p class="title">{{ description }}</p>
      }
      @if (message != undefined) {
        <p class="subtitle">{{ message }}</p>
      }
    </div>
    @if (url != undefined) {
      <app-link [url]="url" classes="stretched-link"></app-link>
    }
  </div>
}

@if (!widgetFullsizeBannerHeaderAndMessageTogether) {
  <div class="widget-fullsize-banner" [ngClass]="cssClass" [attr.id]="id" [style.margin-top]="marginTop" [style.margin-right]="marginRight" [style.margin-bottom]="marginBottom" [style.margin-left]="marginLeft">
    <img class="mw-100" [src]="imageUrl" [attr.alt]="imageDescription" />
    @if (description != undefined) {
      <div class="header">{{ description }}</div>
    }
    @if (url != undefined) {
      <app-link [url]="url" classes="stretched-link"></app-link>
    }
    @if (message != undefined) {
      <div class="message mt-auto">{{ message }}</div>
    }
  </div>
}
